export type OrganizationPrimaryContactTranslations = {
  primaryContactTitle: string;
  primaryContactDescription: string;
  primaryContactSaved: (name: string) => string;
};

export const defaultOrganizationPrimaryContactTranslations: OrganizationPrimaryContactTranslations = {
  primaryContactTitle: 'Primary contact',
  primaryContactDescription:
    'The person we contact on behalf of the organization when we need to reach the group. There is one primary contact for the whole organization.',
  primaryContactSaved: (name) => `${name} is now the primary contact`
};
